/* web/style.css .chips: Free and the price keep their size; the type button takes the rest of the row. */
.chips { display: flex; gap: 8px; padding: 2px 1px 4px; min-width: 0; }
.types { flex: 1 1 0; }
.title { font-weight: 600; }
.range { width: 100%; margin: 12px 0; accent-color: var(--selected); }
.foot { display: flex; align-items: center; gap: 10px; }
.foot > :first-child { flex: 1; }
